import { render, staticRenderFns } from "./ChangePriceAlertModal.vue?vue&type=template&id=87da8780&scoped=true"
import script from "./ChangePriceAlertModal.vue?vue&type=script&lang=js"
export * from "./ChangePriceAlertModal.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceAlertModal.vue?vue&type=style&index=0&id=87da8780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da8780",
  null
  
)

export default component.exports